import { appRemoveItem } from "@/lib/auth-storage";

export function clearClientAuthState() {
  if (typeof window === "undefined") {
    return;
  }

  try {
    const appKeys = [
      "jupas_user_preferences",
      "jupas-favourites",
      "toggle-card-table",
      "gradeTableExpanded",
      "sidebarCollapsed",
      "jupas_language",
      "jupas_activity_logs",
    ];

    appKeys.forEach((key) => appRemoveItem(key));
  } catch (error) {
    console.error("Failed to clear browser storage during sign out:", error);
  }
}
